import { Component, Input, OnInit, ViewEncapsulation } from "@angular/core";
import { FormArray, FormBuilder, FormGroup, Validators } from "@angular/forms";

import { select, Store } from "@ngrx/store";
import { Observable, Subscription } from "rxjs";

import {
  PropertyDTO,
  DataTypeCode,
} from "src/app/models/Properties/propertyDTO";
import { AppState, loadedTenantState } from "src/app/store/reducers";

@Component({
  selector: "app-properties",
  templateUrl: "./properties.component.html",
  styleUrls: ["./properties.component.scss"],
  encapsulation: ViewEncapsulation.None,
})
export class PropertiesComponent implements OnInit {
  _properties: PropertyDTO[];

  dataTypeCode = DataTypeCode;

  tenantDataSub: Subscription;
  tenantData$: Observable<any>;
  dateTimeFormat: string;

  @Input() title: string = "Properties.Properties";
  @Input() formArray: FormArray;
  @Input() selectedProperties: PropertyDTO[];
  @Input() set properties(propertyList: PropertyDTO[]) {
    if (propertyList) {
      this._properties = this.sortByMandatory(propertyList);
      this.setPropertiesForm(this._properties);
    }
  }

  constructor(private store: Store<AppState>, private fb: FormBuilder) {
    this.tenantData$ = this.store.pipe(select(loadedTenantState));
  }

  ngOnInit(): void {
    this.loadTenantDateTimeFomat();
  }

  loadTenantDateTimeFomat(): void {
    this.tenantDataSub = this.tenantData$.subscribe((data: any) => {
      if (data) {
        this.dateTimeFormat = data.datetimeFormat;
      }
    });
  }

  sortByMandatory(properties: PropertyDTO[]): PropertyDTO[] {
    return properties.slice().sort((x, y) => {
      return x.mandatory === y.mandatory ? 0 : x.mandatory ? -1 : 1;
    });
  }

  setPropertiesForm(properties: PropertyDTO[]): void {
    properties.forEach((property) => {
      const selectedProperty = this.getSelectedProperty(
        property,
        this.selectedProperties
      );
      this.formArray.push(
        this.fb.group({
          [property.code]: [
            selectedProperty ? selectedProperty.value : "",
            property.mandatory ? Validators.required : [],
          ],
        })
      );
    });
  }

  getSelectedProperty(
    property: PropertyDTO,
    selectedProperties: PropertyDTO[]
  ): PropertyDTO {
    if (!selectedProperties) {
      return;
    }
    return selectedProperties.find((selProp) => selProp.code === property.code);
  }

  getFormLabel(propertyControl: FormGroup): string {
    const [propertyCode] = Object.keys(propertyControl.controls);
    const property = this.getProperty(this._properties, propertyCode);
    return property.description;
  }

  getRequiredIndication(categoryControl: FormGroup): boolean {
    const [propertyCode] = Object.keys(categoryControl.controls);
    const proeprty = this.getProperty(this._properties, propertyCode);
    return proeprty.mandatory;
  }

  getPropertyDataType(propertyControl: FormGroup): DataTypeCode {
    const [propertyCode] = Object.keys(propertyControl.controls);
    const property = this.getProperty(this._properties, propertyCode);
    return property.dataTypeCode;
  }

  getProperty(properties: PropertyDTO[], propertyCode: string): PropertyDTO {
    return properties.find((property) => property.code === propertyCode);
  }

  getFormControlName(propertyControl: FormGroup): string {
    const [propertyCode] = Object.keys(propertyControl.controls);
    return propertyCode;
  }

  clearFormControl(propertyControl: FormGroup): void {
    propertyControl.controls[this.getFormControlName(propertyControl)].setValue("");
    this.formArray.markAsDirty();
  }
}
